<template>
  <div class="min-h-screen bg-gray-950 text-gray-100 flex items-center justify-center p-4 font-sans">
    <div class="w-full max-w-md">
      <div class="text-center mb-8">

      </div>
      <div class="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 shadow-xl">
        <slot />
      </div>
      <footer class="mt-8 text-center text-sm text-gray-600">

      </footer>
    </div>
  </div>
</template>

<script setup>
// Layout for authentication pages
</script>
